export default "__VITE_ASSET__CWziFJkR__"